<ng-container>
  <div class="flex justify-between gap-6">
    <p class="subtitle pt-4 pl-4 ipad-pro-landscape:pt-1">{{prefix}}</p>
    <ng-content></ng-content>
  </div>
</ng-container>
